import AuthRoutes from "../components/pages/auth/AuthRoute";
import DashboardRoutes from "../components/pages/dashboard/DashboardRoute";

export const standardRoutes = [...DashboardRoutes];

export const guestRoutes = [...AuthRoutes];
